import React from "react";

import Entities from "../../components/Entities";

function Manufacturers() {
  return (
    <Entities
      shema={{
        searchFromServer: true,
        searchRoute: "manufacturers",
        fields: [
          { name: "Name", propertyName: "name", search: true },
          {
            name: "Status",
            propertyName: "status",
            filter: true,
            filterOptions: [
              { label: "Active", value: "ACTIVE" },
              { label: "Competitor", value: "COMPETITOR" },
              { label: "Inactive", value: "INACTIVE" },
            ],
          },
        ],
      }}
    />
  );
}

export default Manufacturers;
